import React from "react";
import JDExpressForm, { JDExpressFormValues } from "./JDExpressForm";
import { Form, Modal } from "antd";
import { getJDLAuthUrl, getJDWLAuthUrl } from "@/services/api/ewaybillAuth";
import { useRequest } from "ahooks";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";

interface AddJDExpressModalProps extends InjectBaseModalProps {}

const AddJDExpressModal: React.FC<AddJDExpressModalProps> = function (props) {
  const { visible, onCancel } = props;

  const [form] = Form.useForm<JDExpressFormValues>();

  const { run: onOk, loading } = useRequest(
    async () => {
      const { logisticsCompany, username } = await form.validateFields();

      // 京东物流云
      if (logisticsCompany === "JDL") {
        const { url } = await getJDLAuthUrl(username);

        window.location.href = url;

        onCancel();

        return;
      }

      const { url } = await getJDWLAuthUrl(username, logisticsCompany);

      window.location.href = url;

      onCancel();
    },
    {
      manual: true,
    }
  );

  return (
    <Modal
      title="授权使用京东物流"
      visible={visible}
      onCancel={onCancel}
      okText="授权"
      confirmLoading={loading}
      onOk={onOk}
    >
      <JDExpressForm form={form} />
    </Modal>
  );
};

export default React.memo(AddJDExpressModal);
